import { Box, Button, Grid, Typography } from '@mui/material';
import SimpleDialog from '../../../../common-components/dialog/SimpleDialog';
import { MyFleetVessel } from '../../../../models/my-fleet.model';
import { Destination } from '../../../../models/pro.model';

interface MyFleetVesselDestinationDialogProps {
  open: boolean;
  onClose: () => void;
  destination: Destination | null;
  vessel: MyFleetVessel | null;
}

function MyFleetVesselDestinationDialog({
  open,
  onClose,
  destination,
  vessel,
}: MyFleetVesselDestinationDialogProps) {
  const CONTENT_MIN_HEIGHT = 80;
  const CONTENT_MAX_HEIGHT = 500;
  const CONTENT_MAX_WIDTH = 500;

  const { raw } = destination || {};

  const renderTitle = () => (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Typography>
        {`The vessel's AIS destination could not be matched to any port's UNLOCODE. See details below.`}
      </Typography>
    </Box>
  );

  const renderActions = () => (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        width: '100%',
        gap: 1,
        mt: 1,
      }}
    >
      <Button
        variant="contained"
        onClick={onClose}
        data-testid="vessel-destination-error-dialog-close-button"
        sx={{ mb: 0, minWidth: '80px' }}
      >
        Close
      </Button>
    </Box>
  );

  const renderContent = () => (
    <Box
      sx={{
        minHeight: CONTENT_MIN_HEIGHT,
        maxHeight: CONTENT_MAX_HEIGHT,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        gap: 1,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          flexGrow: 1,
          mt: 1,
          mb: 1,
        }}
      >
        {renderTitle()}
      </Box>
      <Grid container spacing={1} sx={{ paddingLeft: 2, width: '100%', mb: 1 }}>
        <Grid item xs={4}>
          <Typography>Vessel Name:</Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography>{vessel ? vessel.name : 'Unknown Vessel'}</Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography>IMO:</Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography>{vessel ? vessel.imo : 'Unknown IMO'}</Typography>
        </Grid>
        <Grid item xs={4}>
          <Typography>Destination input:</Typography>
        </Grid>
        <Grid item xs={8}>
          <Typography>
            {raw ? `'${raw}'` : 'Destination not specified'}
          </Typography>
        </Grid>
      </Grid>

      <Typography>
        {`You can retrieve a PRO report for this vessel from the port's 'PRO
        Report' tab, provided you know its destination port.`}
      </Typography>
    </Box>
  );

  return (
    <SimpleDialog
      onClose={onClose}
      open={open}
      title="Vessel destination"
      width={CONTENT_MAX_WIDTH}
      actions={renderActions()}
      data-testid="vessel-destination-error-dialog"
    >
      {renderContent()}
    </SimpleDialog>
  );
}

export default MyFleetVesselDestinationDialog;
